import React from "react";

/**
 * Checkbox label
 *
 * @param {string} label - The label text to display for the radio button.
 * @param {JSX.Element} [icon] - An icon decoration to be displayed with the label.
 */
const CheckboxOption = ({ label, icon, className }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span>{label}</span>
      {icon ? icon : null}
    </div>
  );
};

export default CheckboxOption;
